export interface LockPositionT {
  min: Record<string, number>;
  max: Record<string, number>;
}

/**
 * Compute absolute CSS positions for the min and max lock icons on a given axis.
 *
 * For X axes (position "top" or "bottom"): locks sit at the left and right edges
 * of the grid area, vertically offset to track the axis.
 *
 * For Y axes (position "left" or "right"): locks sit at the top and bottom edges
 * of the grid area, horizontally offset to track the axis.
 */
export const getLockPosition = (
  position: string,
  gridLeft: number,
  gridRight: number,
  gridTop: number,
  gridBottom: number,
  nameGap: number,
  offset: number
): LockPositionT => {
  switch (position) {
    case "bottom": //bottom x-axis
      return {
        min: {
          bottom: Number(gridBottom) - offset - 40,
          left: gridLeft - 9
        },
        max: {
          bottom: Number(gridBottom) - offset - 40,
          right: gridRight - 9
        }
      };
    case "top": // top x-axis
      return {
        min: {
          top: Number(gridTop) - offset - 32,
          left: gridLeft - 9
        },
        max: {
          top: Number(gridTop) - offset - 32,
          right: gridRight - 9
        }
      };
    case "left": // left y-axis
      return {
        min: {
          bottom: gridBottom + 9,
          left: offset > 0 ? offset - 32 : gridLeft - nameGap - 9
        },
        max: {
          top: gridTop + 16,
          left: offset > 0 ? offset - 32 : gridLeft - nameGap - 9
        }
      };
    case "right": // right y-axis
      return {
        min: {
          bottom: gridBottom + 9,
          right: offset > 0 ? offset - 40 : gridRight - nameGap - 1
        },
        max: {
          top: gridTop + 16,
          right: offset > 0 ? offset - 40 : gridRight - nameGap
        }
      };
    default:
      return { min: {}, max: {} };
  }
};

export const getLogButtonPosition = (
  position: string,
  leftSpacing: number,
  rightSpacing: number,
  topSpacing: number,
  bottomSpacing: number,
  nameGap: number,
  offset: number
): Record<string, number> => {
  switch (position) {
    case "left":
      return {
        left: offset > 0 ? 5 : leftSpacing - nameGap - 15,
        bottom: bottomSpacing
      };
    case "right":
      return {
        right: offset > 0 ? 5 : rightSpacing - nameGap - 15,
        bottom: bottomSpacing
      };
    case "top":
      return {
        top: Number(topSpacing) - offset - 30,
        right: rightSpacing + 16
      };
    case "bottom":
      return {
        bottom: Number(bottomSpacing) - offset - 45,
        right: rightSpacing + 16
      };
    default:
      return {};
  }
};
